import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FaqRowDataI } from '../constants/constants';
import { saveAs } from 'file-saver';


@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private apiServiceUrl = environment.apiUrl;
  public selectedTicketRequestRow!: FaqRowDataI;
  private selectedRequestSubject: Subject<FaqRowDataI> = new Subject();
  private selectedTicketResponseSubject: Subject<any> = new Subject<any>();
  public deleteFaqRecord=new BehaviorSubject<any>(null);


  constructor(private http: HttpClient) { }
  public SubmitFaq(clientName: string, file: File, industry: string): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('clientName', clientName);
    formData.append('transcriptFile', file, file.name);
    formData.append('industry', industry);
    const url = `${this.apiServiceUrl}/aipo/faq/api/submit`;
    return this.http.post(url, formData);
  }

  public getAllFaqRequest(): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/faq/api/requestList`;
    return this.http.get(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  public getSelectedFaqDetails(requestId: string): Observable<any> {
    const url = `${this.apiServiceUrl}/aipo/faq/api/faqResponse?requestId=${requestId}`;
    return this.http.get(url, { responseType: 'blob' }).pipe(
      map((response: Blob) => {
        return response;
      })
    );
  }

  public setSelectedTestDesignRow(row: FaqRowDataI) {
    this.selectedTicketRequestRow = row;
    this.selectedRequestSubject.next(row);
    if (row) {
      this.getSelectedFaqDetails(row.requestId).subscribe((res: Blob) => {
        // Convert Blob response to Excel file and trigger download
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `${row.requestId}-${row.createdOn}-faq.xlsx`);
      });
    }
  }
  public getSelectedRequest() {
    return this.selectedTicketRequestRow;
  }
  public deleteFaq(requestId:number){
    const apiUrl=`${this.apiServiceUrl}/aipo/faq/api/delete?requestId=${requestId}`;
    return this.http.delete(apiUrl);   
  }
}
